import OneTrustFilter from './OneTrustFilter';

export default OneTrustFilter;
